export default __webpack_public_path__ + "static/media/Wallet_fill.b5a5e8e2.svg";